import Model from './Model';
import GetBlockedCountryResponse from '../CRM/Responses/BlockedCountriesResponse';

export default class BlockedCountry extends Model {
    readonly id: number;
    readonly name: string;
    readonly iso_code: string;
    readonly created_at: string;

    constructor(menu: Partial<GetBlockedCountryResponse>) {
        super();
        this.assignDataToProps(menu, ['id', 'name', 'iso_code', 'created_at']);
    }
}
